import { GridDensity } from '@mui/x-data-grid-pro';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { PreferredAreaUnit } from './ports';

export type IntelUIState = {
  isMapHidden: boolean;
  isLegendHidden: boolean;
  enableIndividualMapSelections: boolean;
  preferredAreaUnits: PreferredAreaUnit;
  tableDensity: GridDensity;
};

const isMapVisibleOnLoad = !window.location.search.includes('hide_map=true');

const initialState: IntelUIState = {
  isMapHidden: !isMapVisibleOnLoad,
  isLegendHidden: false,
  enableIndividualMapSelections: true,
  preferredAreaUnits: 'section',
  tableDensity: 'standard',
};

export const createIntelUiSlice = (sliceName: string) =>
  createSlice({
    name: sliceName,
    initialState,
    reducers: {
      show: (state) => {
        state.isMapHidden = false;
      },
      hide: (state) => {
        state.isMapHidden = true;
      },
      toggleMap: (state) => {
        state.isMapHidden = !state.isMapHidden;
      },
      toggleLegend: (state) => {
        state.isLegendHidden = !state.isLegendHidden;
      },
      setPreferredAreaUnits: (
        state,
        { payload }: PayloadAction<PreferredAreaUnit>
      ) => {
        state.preferredAreaUnits = payload;
      },
      changeTableDensity: (state, { payload }: PayloadAction<GridDensity>) => {
        state.tableDensity = payload;
      },
      toggleIndividualMapSelections: (state) => {
        state.enableIndividualMapSelections =
          !state.enableIndividualMapSelections;
      },
    },
  });

export const intelUiSlice = createIntelUiSlice('intel-ui');
